import produce from 'immer';

import type { ClubRecentTournamentSummary } from '@swf/generated/types/api/v0/SwHomeGames';
import { PKR_INITIAL_STATE } from '@swf/poker';

export const setRecentTournamentSummary = (
  state = PKR_INITIAL_STATE,
  summaries: ClubRecentTournamentSummary[] = []
) =>
  produce(state, (draft) => {
    draft.clubRecentTournamentSummary = summaries;
  });
